import { createApp } from 'vue';
import { imageUrl } from './utils/image-url';
import WhatsOnCalendar from './whats-on-calendar.vue';
import WhatsOnEvents from './whats-on-events.vue';
import WhatsOnEvent from './whats-on-event.vue';
import CalendarList from './calendar-list.vue';
import CalendarListEvent from './calendar-list-event.vue';
import CalendarFilters from './calendar-filters.vue';
import CalendarPopup from './calendar-popup.vue';
import DateSelector from './date-selector.vue';
import SearchResults from './search-results.vue';
import OrchestraRoster from './orchestra-roster.vue';
import OrchestraItem from './orchestra-item.vue';
import ArticleListHub from './article-list-hub.vue';
import PostItemHub from './post-item-hub.vue';
import ProgramListing from './program-listing.vue';
import ProgramListingItem from './program-listing-item.vue';
import FavoriteButton from './favorite-button.vue';
import WhatsOnFavorites from './whats-on-favorites.vue';

let app = null;

document.addEventListener('DOMContentLoaded', () => {
    const mountPoint = document.querySelector('#widget-bootstrap');
    if (!mountPoint) {
        console.error('Mount point #widget-bootstrap is missing.');
        return;
    }

    if (mountPoint.__vue_app__) {
        return;
    }

    const App = {
        data() {
            return {};
        },
        delimiters: ['${', '}']
    }

    app = createApp(App);

    // Provide the imageUrl function globally
    app.provide('imageUrl', imageUrl);

    app.component('whats-on', WhatsOnCalendar);
    app.component('whats-on-events', WhatsOnEvents);
    app.component('whats-on-event', WhatsOnEvent);
    app.component('calendar-list', CalendarList);
    app.component('calendar-list-event', CalendarListEvent);
    app.component('calendar-filters', CalendarFilters);
    app.component('calendar-popup', CalendarPopup);
    app.component('date-selector', DateSelector);
    app.component('search-results', SearchResults);
    app.component('orchestra-roster', OrchestraRoster);
    app.component('orchestra-item', OrchestraItem);
    app.component('article-list', ArticleListHub);
    app.component('post-item', PostItemHub);
    app.component('program-listing', ProgramListing);
    app.component('program-listing-item', ProgramListingItem);
    app.component('favorite-button', FavoriteButton);
    app.component('whatson-favorites', WhatsOnFavorites);

    app.mount(mountPoint);

    mountPoint.__vue_app__ = app;
});
